// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isGenerativeAiStandardsRunHistoryResultItem = objectOf({
  at: number,
  agent_ids: arrayOf(string),
  agent_names: arrayOf(string),
  runs: number,
  test_run: boolean,
});

export const isGenerativeAiStandardsRunHistoryResult = objectOf({
  results: arrayOf(isGenerativeAiStandardsRunHistoryResultItem),
});
